const tableConfig = {
  todayTable() {
    return {
      title:              'New Leads',
      subtitle:           null,
      scope:              'today_new_leads',
      resource:           '/v1/leads',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'referred_at',
        title:  'Referred On',
      },
    };
  },

  followUpTable() {
    return {
      title:              'Tasks Due Today',
      subtitle:           null,
      scope:              'today_or_past_tasks',
      resource:           '/v1/task_leads',
      leadTasks:          true,
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    false,
        bucket:    true,
        owner:     true,
        status:    false,
      },
      tasksBulkAction: {
        owner:       false,
        status:      true,
        category:    false,
        priority:    false,
        dueDate:     true,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: null,
        title:  null,
      },
    };
  },

  backlogTable() {
    return {
      title:              'Backlog',
      subtitle:           'Leads without tasks',
      scope:              'backlog',
      resource:           '/v1/leads',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'referred_at',
        title:  'Referred On',
      },
    };
  },

  onboardingTable() {
    return {
      title:              'Onboarding',
      subtitle:           null,
      scope:              'today_retention_onboarding',
      resource:           '/v1/leads',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:            false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'last_activity_at',
        title:  'Last Contacted',
      },
    };
  },

  retentionFollowUps() {
    return {
      title:              'Tasks Due Today',
      scope:              'today_or_past_tasks',
      subtitle:           null,
      resource:           '/v1/task_leads',
      leadTasks:          true,
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    false,
        bucket:    true,
        owner:     true,
        status:    false,
      },
      tasksBulkAction: {
        owner:       false,
        status:      true,
        category:    false,
        priority:    false,
        dueDate:     true,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: null,
        title:  null,
      },
    };
  },

  todayRetentionTable() {
    return {
      title:              'Retention Reminders',
      subtitle:           'No 1-on-1 contact in the last 30 days',
      scope:              'today_retention_active',
      resource:           '/v1/leads',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'last_activity_at',
        title:  'Last Contacted',
      },
      enableProductionFilter: true,
    };
  },

  backlogRetentionTable() {
    return {
      title:              'Retention Backlog',
      subtitle:           'Team Members without tasks',
      scope:              'backlog_retention',
      resource:           '/v1/leads',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'last_activity_at',
        title:  'Last Contacted',
      },
    };
  },

  recruitingSearchTable() {
    return {
      title:              'Search Results',
      subtitle:           null,
      scope:              'search_results',
      tabs:               true,
      resource:           '/v1/search',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'referred_at',
        title:  'Referred On',
      },
    };
  },

  recruitingLeadsTable() {
    return {
      title:              'Leads',
      subtitle:           null,
      scope:              'recruiting_leads',
      tabs:               true,
      resource:           '/v1/leads',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'referred_at',
        title:  'Referred On',
      },
    };
  },

  trashTable() {
    return {
      title:                   'Trash',
      subtitle:                'Documents that have been in Trash more than 30 days will be automatically deleted.',
      scope:                   'trash_documents',
      resource:                '/v1/documents/trashed_documents',
      trashDocumentBulkAction: {
        permanent_delete: true,
        restore:          true,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      filterable:         false,
      searchable:         false,
      sortBy:             'deleted_at',
      sortDirection: 'desc',
      timestamp:     {
        column: 'deleted_at',
        title:  'Deleted At',
      },
    };
  },

  documentsTable() {
    return {
      scope:              'documents',
      title:              'Documents',
      resource:           '/v1/documents',
      documentBulkAction: {
        delete:           true,
        owner:            true,
        status:           true,
        category:         true,
        related_contacts: true,
      },
      filterable:      true,
      searchable:      true,
      sortBy:         'uploaded_at',
      sortDirection: 'desc',
      timestamp:     {
        column: 'uploaded_at',
        title:  'Uploaded At',
      },
    };
  },

  videosTable() {
    return {
      scope:              'videos',
      title:              'Videos',
      resource:           '/v1/videos',
      videoBulkAction: {
        delete:   true,
        owner:    true,
        category: true,
      },
      filterable:      true,
      searchable:      true,
      sortBy:         'uploaded_at',
      sortDirection: 'desc',
      timestamp:     {
        column: 'uploaded_at',
        title:  'Uploaded At',
      },
    };
  },

  trashVideosTable() {
    return {
      scope:                'trash_videos',
      title:                'Trash',
      subtitle:             'Videos that have been in Trash more than 30 days will be automatically deleted.',
      resource:             '/v1/videos/trashed_videos',
      trashVideoBulkAction: {
        permanent_delete: true,
        restore:          true,
        owner:            false,
        category:         false,
      },
      filterable:         false,
      searchable:         false,
      sortBy:             'deleted_at',
      sortDirection: 'desc',
      timestamp:     {
        column: 'deleted_at',
        title:  'Deleted At',
      },
    };
  },

  jobsTable() {
    return {
      scope:         'jobs',
      title:         'Jobs',
      resource:      '/v1/jobs',
      jobBulkAction: {
        status: true,
        owner:  true,
        delete: true,
      },
      filterable:    true,
      searchable:    true,
      sortBy:        'created_at',
      sortDirection: 'desc',
      timestamp:     {
        column: 'created_at',
        title:  'Created At',
      },
    };
  },

  candidatesTable(jobId) {
    return {
      scope:                'candidates',
      title:                'Candidates',
      resource:             `/v1/jobs/${jobId}/job_applications`,
      candidatesBulkAction: {
        labels:          true,
        notes:           true,
        emails:          true,
        texts:           true,
        campaigns:       true,
        tasks:           true,
        delete:          true,
        bucket:          true,
        owner:           true,
        status:          true,
        remove_from_job: true,
        change_job:      true,
      },
      filterable:    true,
      searchable:    true,
      sortBy:        'created_at',
      sortDirection: 'desc',
      timestamp:     {
        column: 'created_at',
        title:  'Created At',
      },
    };
  },

  retentionSearchTable() {
    return {
      title:              'Search Results',
      subtitle:           null,
      scope:              'search_results',
      tabs:               true,
      resource:           '/v1/search',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'joined_at',
        title:  'Joined On',
      },
    };
  },

  retentionTeamTable() {
    return {
      title:              'Team',
      subtitle:           null,
      scope:              'retention_team',
      tabs:               true,
      resource:           '/v1/leads',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'joined_at',
        title:  'Joined On',
      },
    };
  },

  archivedSearchTable() {
    return {
      title:              'Search Results',
      subtitle:           null,
      scope:              'search_results',
      tabs:               true,
      resource:           '/v1/search',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'joined_at',
        title:  'Joined On',
      },
    };
  },

  archivedTable() {
    return {
      title:              'Archived',
      subtitle:           null,
      scope:              'archived',
      tabs:               true,
      resource:           '/v1/leads',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'joined_at',
        title:  'Joined On',
      },
    };
  },

  referralsTable() {
    return {
      title:              'Referrals Made',
      subtitle:           null,
      scope:              'agent_referrals',
      resource:           '/v1/leads',
      contactsBulkAction: {
        labels:    true,
        notes:     true,
        emails:    true,
        texts:     true,
        campaigns: true,
        tasks:     true,
        delete:    true,
        bucket:    true,
        owner:     true,
        status:    true,
      },
      tasksBulkAction: {
        owner:       false,
        status:      false,
        category:    false,
        priority:    false,
        dueDate:     false,
        description: false,
        deleteTask:  false,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: 'referred_at',
        title:  'Referred On',
      },
    };
  },

  allTasksTable() {
    return {
      title:              'All Tasks',
      subtitle:           null,
      scope:              'all_tasks',
      resource:           '/v1/task_leads',
      task_tabs:          true,
      contactsBulkAction: {
        labels:    false,
        notes:     false,
        emails:    false,
        texts:     false,
        campaigns: false,
        tasks:     false,
        delete:    false,
        bucket:    false,
        owner:     false,
        status:    false,
      },
      tasksBulkAction: {
        owner:       true,
        status:      true,
        category:    true,
        priority:    true,
        dueDate:     true,
        description: true,
        deleteTask:  true,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: null,
        title:  null,
      },
    };
  },

  tasksDueTodayTable() {
    return {
      title:              'Tasks Due Today',
      subtitle:           null,
      scope:              'today_or_past_tasks',
      resource:           '/v1/task_leads',
      task_tabs:          true,
      contactsBulkAction: {
        labels:    false,
        notes:     false,
        emails:    false,
        texts:     false,
        campaigns: false,
        tasks:     false,
        delete:    false,
        bucket:    false,
        owner:     false,
        status:    false,
      },
      tasksBulkAction: {
        owner:       true,
        status:      true,
        category:    true,
        priority:    true,
        dueDate:     true,
        description: true,
        deleteTask:  true,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: null,
        title:  null,
      },
    };
  },

  tasksDueLaterTable() {
    return {
      title:              'Tasks Due Later',
      subtitle:           null,
      scope:              'tasks_due_later',
      resource:           '/v1/task_leads',
      task_tabs:          true,
      contactsBulkAction: {
        labels:    false,
        notes:     false,
        emails:    false,
        texts:     false,
        campaigns: false,
        tasks:     false,
        delete:    false,
        bucket:    false,
        owner:     false,
        status:    false,
      },
      tasksBulkAction: {
        owner:       true,
        status:      true,
        category:    true,
        priority:    true,
        dueDate:     true,
        description: true,
        deleteTask:  true,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: null,
        title:  null,
      },
    };
  },

  tasksOverdueTable() {
    return {
      title:              'Tasks Overdue',
      subtitle:           null,
      scope:              'tasks_overdue',
      resource:           '/v1/task_leads',
      task_tabs:          true,
      contactsBulkAction: {
        labels:    false,
        notes:     false,
        emails:    false,
        texts:     false,
        campaigns: false,
        tasks:     false,
        delete:    false,
        bucket:    false,
        owner:     false,
        status:    false,
      },
      tasksBulkAction: {
        owner:       true,
        status:      true,
        category:    true,
        priority:    true,
        dueDate:     true,
        description: true,
        deleteTask:  true,
      },
      documentBulkAction: {
        delete:           false,
        owner:            false,
        status:           false,
        category:         false,
        related_contacts: false,
      },
      timestamp: {
        column: null,
        title:  null,
      },
    };
  },
};

export default tableConfig;
